import { Message  } from 'element-ui'
export function importDateError(){
    return Message({
        message:'无导出数据',
        type:'warning',
        center:true
      })
}


// WEBPACK FOOTER //
// ./src/utils/functionAll.js